import { useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { useHostProject, useOrganizationId } from '@/hooks/useSwr';
import GraphIcon from '@/icons/GraphIcon.svg?react';
import MessageChatIcon from '@/icons/MessageChatIcon.svg?react';
import RocketShipIcon from '@/icons/RocketShip.svg?react';
import { addQueryParams } from '@/utils/add-query-params';
import {
  appGraphIndexPath,
  appOrganizationPath,
  deploymentsAppIndexPath,
  hostAppIndexPath,
} from '@/utils/constants';

import { Breadcrumb } from '../../components/Breadcrumbs';
import { HostProjectsCrumb } from '../HostProjects/HostProjectsCrumb';
import { OrganizationCrumb } from '../Organization/OrganizationCrumb';

export function GraphCrumb() {
  const organizationId = useOrganizationId();

  const { threadId } = useParams();
  const [searchParams] = useSearchParams();

  const hostProjectId = searchParams.get('hostProjectId');
  const baseUrl = searchParams.get('baseUrl');

  const project = useHostProject(hostProjectId);

  const graphParams = useMemo(() => {
    return {
      organizationId,
      hostProjectId,
      baseUrl,
    };
  }, [organizationId, hostProjectId, baseUrl]);

  return (
    <>
      {hostProjectId ? (
        <>
          <OrganizationCrumb />

          <HostProjectsCrumb
            path={`/${appOrganizationPath}/${organizationId}/${hostAppIndexPath}`}
          />

          <Breadcrumb
            name={project.data?.name ?? 'Deployment'}
            icon={<RocketShipIcon />}
            path={`/${appOrganizationPath}/${organizationId}/${deploymentsAppIndexPath}/${hostProjectId}`}
          />

          <Breadcrumb
            name="Studio"
            path={addQueryParams(`/${appGraphIndexPath}`, graphParams)}
            icon={<GraphIcon className="relative h-6 w-6" />}
            isActive={!threadId}
          />
        </>
      ) : (
        <>
          {organizationId && <OrganizationCrumb />}

          {organizationId && (
            <HostProjectsCrumb
              path={`/${appOrganizationPath}/${organizationId}/${hostAppIndexPath}`}
            />
          )}

          <Breadcrumb
            name="Studio"
            isFirst={!organizationId}
            path={addQueryParams(`/${appGraphIndexPath}`, graphParams)}
            icon={<GraphIcon className="relative h-6 w-6" />}
            isActive={!threadId}
          />
        </>
      )}

      {threadId && (
        <Breadcrumb
          icon={<MessageChatIcon className="h-6 w-6 p-0.5" />}
          name={threadId}
          path={addQueryParams(
            `/${appGraphIndexPath}/thread/${threadId}`,
            graphParams
          )}
          isActive={!!threadId}
        />
      )}
    </>
  );
}
